import React, { useEffect, useState } from 'react';
import { Alert } from '@abyss/web/ui/Alert';
import { Link } from '@abyss/web/ui/Link';
import { useAlertStore } from '@src/store/common/AlertStore';
import { AlertVariantType } from '@src/constants/AlertVariantType';

export const AlertComponent = () => {
  type AlertType = {
    title: string | null;
    variant: string;
    visible: boolean;
    message: string | null;
    isPermanent?: boolean | null;
    link?: {
      text: string;
      url: string;
      openNewTab?: boolean;
    };
    messageAfterLink?: string;
  };

  const initialState: AlertType = {
    title: null,
    variant: AlertVariantType.ERROR,
    visible: false,
    message: '',
  };
  const [alert, setAlert] = useState<AlertType>(initialState);

  const alertState = useAlertStore((state) => state.alertState);
  const showAlert = useAlertStore((state) => state.showAlert);

  useEffect(() => {
    setAlert({
      ...alertState,
      message: alertState.message || '',
    });
  }, [alertState]);

  const handleClose = () => {
    showAlert({
      ...alertState,
      visible: false,
    });
  };

  return (
    <Alert
      title={alert.title}
      variant={alert.variant as 'info' | 'success' | 'error' | 'warning'}
      isVisible={alert.visible}
      onClose={handleClose}
      css={{ 'abyss-alert-root': { margin: '10px 0px' } }}
    >
      {alert.message}
      {alert.link && (
        <Link
          openNewWindow={alert.link.openNewTab}
          css={{ 'abyss-link-root': { marginLeft: '3px', marginRight: '3px' } }}
          href={alert.link.url}
        >
          {alert.link.text}
        </Link>
      )}
      {alert.messageAfterLink}
    </Alert>
  );
};
